class SocialSharing extends HTMLElement {
  constructor() {
    super();
    this.modal = document.getElementById('bt-social-sharing-modal');
    this.selectors = {
      openBtn: '[data-open-share]',
      copyUrlBtn: '.copy-url-btn',
      urlInput: '.bt-addon--sharing__copy-link input',
    };

    MicroModal.init();
  }

  connectedCallback() {
    if (this.modal) {
      this.init();
    }
  }

  init() {
    addEventDelegate({
      selector: this.selectors.openBtn,
      handler: (e) => {
        e.preventDefault();
        MicroModal.show(this.modal.id, {
          onShow: (modal) => {
            document.body.classList.add('bt-opened-modal');
          },
          onClose: (modal) => {
            document.body.classList.remove('bt-opened-modal');
          },
        });
      },
    });

    // Add copy URL functionality
    addEventDelegate({
      selector: this.selectors.copyUrlBtn,
      handler: (e) => {
        e.preventDefault();
        this.copyProductUrl();
      },
    });
  }

  async copyProductUrl() {
    const urlInput = this.modal.querySelector(this.selectors.urlInput);
    if (!urlInput) return;

    const url = urlInput.value;

    try {
      // Use modern clipboard API if available
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        this.showCopySuccess();
      } else {
        // Fallback for older browsers or non-secure contexts
        this.fallbackCopyTextToClipboard(url);
      }
    } catch (err) {
      console.error('Failed to copy URL:', err);
      this.showCopyError();
    }
  }

  fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.showCopySuccess();
      } else {
        this.showCopyError();
      }
    } catch (err) {
      console.error('Fallback copy failed:', err);
      this.showCopyError();
    }

    document.body.removeChild(textArea);
  }

  showCopySuccess() {
    if (window.UtenzoTheme && window.UtenzoTheme.Notification) {
      window.UtenzoTheme.Notification.show({
        type: 'success',
        message: 'Product URL copied to clipboard!',
        delay: 2000,
      });
    } else {
      // Fallback alert if notification system is not available
      alert('Product URL copied to clipboard!');
    }
  }

  showCopyError() {
    if (window.UtenzoTheme && window.UtenzoTheme.Notification) {
      window.UtenzoTheme.Notification.show({
        type: 'error',
        message: 'Failed to copy URL. Please try again.',
        delay: 3000,
      });
    } else {
      // Fallback alert if notification system is not available
      alert('Failed to copy URL. Please try again.');
    }
  }
}
customElements.define('bt-social-sharing', SocialSharing);
